import DropdownMenu from './_dropdown_menu';
import Icon from './_icon';

import {userCanCurate} from '../modules/roles_utils';
import {alertMessageForPublishedBattlecard} from '../modules/battlecard_utils';
import {isValidId} from '../modules/utils';

import {BATTLE_CARD_LAYOUT} from '../modules/constants/ui';

import classNames from 'classnames';
import {withRouter} from 'react-router-dom';

class BattlecardToolbar extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    users: PropTypes.objectOf(PropTypes.object),
    setDefaultSuccess: PropTypes.bool,
    onFullscreenClick: PropTypes.func.isRequired,
    onSelectLayout: PropTypes.func.isRequired,
    onSetDefaultLayout: PropTypes.func.isRequired
  };

  static defaultProps = {
    history: {},
    location: {},
    users: {},
    setDefaultSuccess: false,
    onFullscreenClick() {},
    onSelectLayout() {},
    onSetDefaultLayout() {}
  };

  componentDidMount() {
    // DEBUG
    console.log('BattlecardToolbar.componentDidMount: props: %o', this.props);

    this._isMounted = true;

    const {battlecard, requestUser} = this.context.utils;
    const {review} = battlecard || {};

    if(review && review.byUserId) {
      requestUser({userId: review.byUserId});
    }
  }

  _copyPlainTextToClipboard = text => {
    const input = document.createElement('textarea');
    let copiedStatus = false;

    document.body.appendChild(input);
    // Taken from: http://stackoverflow.com/questions/25099409/copy-to-clipboard-as-plain-text/25275151#25275151
    input.value = _.escape(text || ''); // Escape to avoid XSS when providing unknown input (see stackoverflow answer);
    input.focus();
    input.select();

    // Try to copy
    try {
      copiedStatus = document.execCommand('copy'); // FF 41+, Chrome, IE 9+
    }
    catch(e) {
      copiedStatus = false;
    }

    input.remove();

    return copiedStatus;
  };

  isPreviewing = () => {
    const {location} = this.props;
    const queryParams = new URLSearchParams(location.search);
    const previewGroup = queryParams.get('previewing');
    const visibilityGroup = parseInt(previewGroup, 10);

    return isValidId(visibilityGroup, true);
  };

  handleShareClick = () => {
    this.renderShareModal();
  };

  handleShareModalCloseClick = () => {
    this.context.utils.dialog.remove('modal-battlecard-share');
  };

  handlePrintClick = event => {
    if(event) {
      event.preventDefault();
    }

    this.context.utils.dialog.remove('modal-battlecard-share');

    // Delay to hide modal before opening print dialog
    setTimeout(() => {
      window.print();
    }, 400);
  };

  handleCopyURLClick = text => {
    const copied = this._copyPlainTextToClipboard(text);
    let alertMessage;

    if(copied) {
      alertMessage = '<strong>Copied URL to clipboard!</strong><br /><br />You can now share with team members.';
    }
    else {
      alertMessage = 'To copy, select the URL then copy &amp; paste to share with your team members.';
    }

    this.context.utils.dialog.alert(alertMessage);
  };

  handleCreateCommentClick = () => {
    this.context.utils.handleCreateProfileCommentClick(this.context.utils.battlecard.id, 'battlecard');
  };

  handleToggleDraftClick = () => {
    const {battlecard} = this.context.utils;

    if(_.isEmpty(battlecard)) {
      return;
    }

    const isDraft = !battlecard.isDraft;
    const title = battlecard.title || '(Untitled Battlecard)';
    const battlecardOptions = {
      id: battlecard.id,
      isDraft
    };

    this.context.api.battlecardCreateOrUpdate(battlecardOptions, () => {
      // force update .context data
      this.forceUpdate();

      const message = alertMessageForPublishedBattlecard(title, !isDraft);

      this.context.utils.dialog.alert(message);
    });
  };

  handleMarkAsReviewedClick = () => {
    const {battlecard} = this.context.utils;

    if(_.isEmpty(battlecard)) {
      return;
    }

    // DEBUG
    console.log('BattlecardToolbar.handleMarkAsReviewedClick: battlecard: %o', battlecard);

    const battlecardOptions = {
      id: battlecard.id,
      profileId: battlecard.profile.id,
      markAsReviewed: true
    };

    this.context.api.battlecardCreateOrUpdate(battlecardOptions, () => {
      // force update .context data (in this case it's the battlecard.reviewedAt timestamp)
      this.forceUpdate();

      this.context.utils.dialog.alert(
        `<strong>Marked "${battlecard.title || '(Untitled Battlecard)'}" as reviewed!</strong><br /><br />
        Your team members can now see that this battlecard is up-to-date.`
      );
    });
  };

  handleReviewUserClick = userId => {
    const {history} = this.props;

    if(!userId) {
      return;
    }

    history.push(`/users/${userId}`);
  };

  handleDonePreviewingClick = () => {
    const {history, location} = this.props;
    const queryParams = new URLSearchParams(location.search);

    queryParams.delete('previewing');

    history.push({
      pathname: location.pathname.replace(/(\/view\b)(?!.*\1)/, '/edit'),
      search: queryParams.toString()
    });
  };

  renderShareModal = () => {
    const uiModalContent = (
      <div>
        <div className="u-mb-xxs"><i className="fa fa-lock" /> <strong>Share Private Link</strong></div>
        <div className="u-mb-xs">Only team members in Klue can access this battlecard</div>
        <div className="grid-row">
          <div className="grid-row_child grid-row_child--grow">
            <input type="text" className="form-control u-w100 disabled" readOnly={true} value={window.location} />
          </div>
          <div className="grid-row_child">
            <div className="button-legacy button-legacy--size-normal button-legacy--primary" onClick={() => this.handleCopyURLClick(window.location)}>Copy</div>
          </div>
        </div>
        <div className="u-pt-l text-right">
          <div className="button-legacy button-legacy--size-normal button-legacy--secondary button-legacy--caps"
            onClick={this.handleShareModalCloseClick}><strong>Close</strong></div>
        </div>
      </div>
    );

    this.context.utils.dialog.create({
      id: 'modal-battlecard-share', // calling with same id with just update the contents
      _wideMode: true,
      content: uiModalContent
    });
  };

  getCurrentBattlecardCardIds = () => {
    const {battlecard} = this.context.utils;
    let currentCards = [];

    if(battlecard && battlecard.cards) {
      currentCards = (battlecard.cards.desktop || []).filter(cardId => parseInt(cardId, 10) > -1);
    }

    return currentCards;
  };

  renderReview = () => {
    const {users} = this.props;
    const {user, battlecard, battlecard: {review = {}}} = this.context.utils;
    const {isDraft} = battlecard;
    const uiReviewedAtTime = (review && review.reviewedAt) ? `${moment(review.reviewedAt).fromNow(true)} ago` : '(Never)';
    const reviewedByUser = (review && review.byUserId) ? (users || {})[review.byUserId] : null;
    const uiReview = [];
    let reviewedByRegion;

    if(reviewedByUser) {
      reviewedByRegion = (
        <div className="toolbar-item_text toolbar-item_text--link" onClick={() => this.handleReviewUserClick(reviewedByUser.id)}>
          @{reviewedByUser.username || 'team_member'}
        </div>
      );
    }

    const currentTitle = battlecard.title !== null && battlecard.title.length > 0 ? battlecard.title : '(Untitled battlecard)';

    uiReview.push(
      <div key={'review-msg'} className="toolbar-item">
        <div className="toolbar-item_text toolbar-item_text--bold">{currentTitle}</div>
        <div
          className="toolbar-item_text"
          data-tracking-id="battlecard-reviewed-label">&ndash;&nbsp; Reviewed: {uiReviewedAtTime}{reviewedByUser ? ' by' : ''}</div>
        {reviewedByRegion}
      </div>
    );

    if(userCanCurate({user})) {
      uiReview.push(
        <div
          key={'review-btn'}
          className="toolbar-item toolbar-action-button"
          onClick={this.handleMarkAsReviewedClick}
          data-tracking-id="battlecard-mark-as-reviewed">Mark as reviewed</div>
      );

      uiReview.push(<div key={'publish-btn'} className="toolbar-item toolbar-action-button" onClick={this.handleToggleDraftClick}>
        {isDraft ? 'Publish' : 'Unpublish'}
      </div>);
    }

    return uiReview;
  };

  render() {
    const {onSetDefaultLayout, setDefaultSuccess, onSelectLayout, onFullscreenClick} = this.props;
    const previewing = this.isPreviewing();
    const {utils} = this.context;

    const currentCards = this.getCurrentBattlecardCardIds();
    const battlecardHasContent = currentCards.length > 0;
    const {user, battlecard, getCuratorsForContainer, printBattlecardDisabled = () => false} = utils;
    let uiActionButtons = null;
    let donePreviewingButton = null;

    if(previewing) {
      donePreviewingButton = (
        <div key="done-previewing" className="toolbar-button toolbar-button--green" onClick={this.handleDonePreviewingClick}>DONE PREVIEWING</div>
      );
    }

    // Only render the action buttons if we have cards
    if(battlecardHasContent) {
      const userLayoutPrefs = user.userData.battlecardLayouts || {};
      const layout = userLayoutPrefs[battlecard.id]
        ? userLayoutPrefs[battlecard.id]
        : battlecard.layout !== 'unset'
          ? battlecard.layout
          : BATTLE_CARD_LAYOUT.single;
      let commentsCountBadge = null;

      const layoutOptions = [
        [BATTLE_CARD_LAYOUT.single, (<div key="view-icon1" className="dropdown-item"><Icon icon="battlecard-single" width="100" height="100" /></div>)],
        [BATTLE_CARD_LAYOUT.masonry, (<div key="view-icon2" className="dropdown-item"><Icon icon="battlecard-masonry" width="100" height="100" /></div>)],
        [BATTLE_CARD_LAYOUT.hero, (<div key="view-icon3" className="dropdown-item"><Icon icon="battlecard-hero" width="100" height="100" /></div>)],
        [BATTLE_CARD_LAYOUT.stacker, (<div key="view-icon4" className="dropdown-item"><Icon icon="battlecard-stacker" width="100" height="100" /></div>)]
      ];
      const setAsDefault = (
        <div className="battlecard-setDefault">
          <span className="xtra">Set as default for everyone?</span>
          <button
            type="button"
            className="button button--small button-setDefault"
            data-action="setDefault"
            title="Set as default layout for all users"
            onClick={onSetDefaultLayout}><span className="xtra">Set as </span>default</button>
          <i className={classNames('battlecard-setDefault-status', {
            'battlecard-setDefault-status--success': setDefaultSuccess
          })} />
        </div>
      );
      const battlecardCurators = getCuratorsForContainer({
        containerId: battlecard.id,
        containerType: 'battlecard'
      });
      const canSetDefault = userCanCurate({user}) && ((battlecardCurators.length === 0) || battlecardCurators.includes(user.id));

      if(battlecard.commentsCount > 0) {
        commentsCountBadge = (
          <div className="toolbar-button_indicator">{battlecard.commentsCount}</div>
        );
      }

      let printButton = null;

      if(!printBattlecardDisabled()) {
        printButton = (
          <div className="toolbar-button" onClick={this.handlePrintClick} title="Print">
            <div className="toolbar-button_icon"><Icon icon="print" width="24" height="24" /></div>
          </div>
        );
      }

      uiActionButtons = (
        <div className="toolbar_right">
          <div className="toolbar-button" onClick={onFullscreenClick} title="Fullscreen">
            <div className="toolbar-button_icon"><Icon icon="fullscreen" width="24" height="24" /></div>
          </div>
          <div className="toolbar-button" onClick={this.handleCreateCommentClick} title="Comment" data-tracking-id="battlecard-title-commment">
            <div className="toolbar-button_icon"><Icon icon="comment" width="24" height="24" /></div>
            {commentsCountBadge}
          </div>
          <div className="toolbar-button" onClick={this.handleShareClick} title="Share" data-tracking-id="battlecard-title-share">
            <div className="toolbar-button_icon"><Icon icon="share" width="24" height="24" /></div>
          </div>
          {printButton}
          <DropdownMenu
            id="battlecardLayoutDropdown"
            values={layoutOptions}
            label="Layouts"
            dataTrackingId="battlecard-layout-button"
            selectCallback={onSelectLayout}
            showSelectedValueWhenCollapsed={false}
            className="battlecard-layout-dropdown"
            selectedValue={layout}>
            {canSetDefault && setAsDefault}
          </DropdownMenu>
        </div>
      );
    }

    return (
      <div className="toolbar">
        <div className="toolbar_left" data-tracking-id="battlecard-toolbar-left">
          {battlecardHasContent && this.renderReview()}
          {donePreviewingButton}
        </div>
        {uiActionButtons}
      </div>
    );
  }

}

export default withRouter(BattlecardToolbar);
